;(function ($) {
  'use strict';

	$(document).ready(function() {
		initialize_menuMain();
    changeGoogleTranslateLabel();
    // iamA_select();
	});

	function initialize_menuMain() {
    const $body = $('body');
    const $html = $('html');
    const $header = $('.header');
    let $submenuToggles = $('.menu__submenu-toggle', $header);

    // adds classes to items bases on its label
    $('.main-menu > .menu-item > a').each(function() {
      let $copy = $(this).text();
      let $class = $copy.toLowerCase().replace(/[\u0300-\u036f]/g, '') // Remove accents
                    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
                    .replace(/\-\-+/g, '-') // Replaces multiple hyphens by one hyphen
                    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
      $(this).parent().addClass($class);
    });

    // Submenu toggle
    $submenuToggles.click(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      var $containerItem = $(this).parent();
      var $this = $(this);

      // desktop
      if ( $('.menu-main-toggle').css('display') == 'none' ) {

      	// if submenu is closed
        if ( !$(this).parents('.submenu--revealed').length ) {

        	// close all other submenus
        	$(this).parents('.main-menu').find('.submenu--revealed')
        		.attr('aria-expanded', false)
          	.removeClass('submenu--revealed')
            .find('.menu__submenu').hide();

          $(this).parent().attr('aria-expanded',true);
          $(this).attr('title', $(this).attr('title').replace('Open','Close'));
        }
        // if submenu is open
        else {
        	$(this).attr('title', $(this).attr('title').replace('Close','Open'));
        	$(this).parent().attr('aria-expanded',false);
        }

        $(this).next('.menu__submenu').toggle()
          .parent().toggleClass('submenu--revealed');
      }


      // mobile
      else {
        // if submenu is closed
        if ( !$(this).parents('.submenu--revealed').length ) {

          // close all other submenus
          $(this).parents('.main-menu').find('.submenu--revealed')
            .attr('aria-expanded', false)
            .removeClass('submenu--revealed')
            .find('.menu__submenu').slideUp();

          $(this).parent().attr('aria-expanded',true);
          $(this).attr('title', $(this).attr('title').replace('Open','Close'));
        }
        // if submenu is open
        else {
          $(this).attr('title', $(this).attr('title').replace('Close','Open'));
          $(this).parent().attr('aria-expanded',false);
        }

        $(this).next('.menu__submenu').slideToggle()
          .parent().toggleClass('submenu--revealed');
      }
    });
  }

  // Change "Select Language" to only "Language"
  function changeGoogleTranslateLabel() {
    setTimeout(function() {
      let languageLabel = $('.goog-te-gadget-simple').find('span').find('a').find('span').first();
      console.log('languageLabel', languageLabel);
      if ( languageLabel.length ) {
        languageLabel.text('Language');
      }
    }, 1000);
  }

})(jQuery);